module.exports = __webpack_public_path__ + "img/warning.1fa4f73a.png";